import { createSlice } from "@reduxjs/toolkit";
import { fetchProductDetails, searchQ } from "../actions/productActions";

const ProductReducers = createSlice({
    name: 'ProductReducers',
    initialState: {
        loader: false,
        errors: null,
        product: {},
        products: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /**
             * Product Details
             */
            .addCase(fetchProductDetails.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchProductDetails.fulfilled, (state, action) => {
                state.loader = false;
                state.product = action.payload;
            })
            .addCase(fetchProductDetails.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * Search Products
             */
            .addCase(searchQ.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(searchQ.fulfilled, (state, action) => {
                state.loader = false;
                state.products = action.payload;
            })
            .addCase(searchQ.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            });
    }
});

export default ProductReducers.reducer;
